<script lang="ts" setup>
import { toHtmlMessage, useTagModal } from '../libs/util'

const emit = defineEmits(['tagClick'])
defineProps({
  text: { type: String, required: true },
  is: { type: String, default: 'div' }
})
const { open: openTagModal } = useTagModal()
const handleClick = (e: Event) => {
  const target = e.target as HTMLElement
  if (target.tagName === 'A' && target.dataset.hashtag) {
    e.preventDefault()
    openTagModal(target.dataset.hashtag)
    emit('tagClick', target.dataset.hashtag)
  }
}
</script>

<template>
  <component class="MessageList-item-text" v-html="toHtmlMessage(text)" @click="handleClick" :is="is" />
</template>

<style lang="scss" scoped>
*,
*::v-deep(*) {
  user-select: text;
}
</style>
